const list = [
    '100W AEG ARM28612 + RIN70124 M VSA SON 100W',
    '100W AEG ARM28612 + RIN70124 M VSA SON 100W MGRIJS',
    '100W AEG ARM28612 + RIN70124 M VSA SON 100W Onbekend',
    '100W AEG ARM28612 + RIN70124 M VSA SON 100W RAL7038',
    '100W AEG KLEINE KOFFER  M VSA SON/CDO-ET100W',
    '100W AEG KLEINE KOFFER  M VSA SON/CDO-ET100W MGRIJS',
    '100W AEG KLEINE KOFFER  M VSA SON/CDO-ET100W RAL7038',
    '100W AEG OVERSP.KOFFER SON/CDO-ET EVSA',
    '100W AEG OVERSP.KOFFER SON/CDO-ET EVSA MGRIJS',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796)',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796) GGALV',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796) MGRIJS',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796) Onbekend',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796) RAL3007',
    '100W AEG OVERSPANNINGS ARM. Z/APP (SON100W-055796) RAL7038',
    '100W BOLARMATUUR 55 EVSA 3007 SON-T100W',
    '100W BOLARMATUUR 55 EVSA 7038 SON-T100W',
    '100W CONSTRUCTIONS-LICHT AMSTERDAM 1XCDO-ET100 ',
    '100W CONSTRUCTIONS-LICHT AMSTERDAM 1XCDO-ET100 RAL9006',
    '100W HAHN A11 1XCDO-ET/SON 100W E40 ',
    '100W HAHN A11 1XCDO-ET/SON 100W E40 Onbekend',
    '100W HAHN A11 1XCDO-ET/SON 100W E40 RAL9007',
    '100W HAHN A11 HQIE / HCI-E/P 100W E27 ',
    '100W HAHN A11 HQIE / HCI-E/P 100W E27 Onbekend',
    '100W JARNKONST GROOT GRIJS M/APP SON 100W Onbekend',
    '100W RAGNI PRO550  SON_SON-T_CDO-ET_CDO-TT Onbekend',
    '100W RAGNI THYRIA 540L SON+ 100WATT OVERSPANNINGSA MGRIJS',
    '100W RAGNI THYRIA 540L SON+ 100WATT OVERSPANNINGSA RAL6034',
    '100W ZUMTOBEL VICTOR 7401B KLEIN CDO-SON  7038',
    '100W ZUMTOBEL VICTOR 7401B KLEIN CDO-SON 7038 ',
    '100W ZUMTOBEL VICTOR 7403B GROOT CDO-SON  7038',
    '100W ZUMTOBEL VICTOR 7403B GROOT CDO-SON 7038 ',
    '100W ZUMTOBEL VICTOR 7403B GROOT CDO-SON 7038 MGRIJS',
    '123W BOLA 55 6BLS12 ERS 3K 12249lm 500mA A-SYM RAL7038',
    '123W BOLA 55 6BLS12 LRE 3K 12400Lm 500mA SYM RAL7038',
    '123W BOLA 55 6BLS12 LRE 3K 12400Lm RAL7038 Sym',
    '124W BOL APOLLO GROOT ASYM ERS 10000lm 950mA R7038',
    '124W BOLA55 ORALED40 LED GR A-SYM LRM 40 X LUXEON T950mA K3000 R7038',
    '124W BOLA55 ORALED40 LED GR SYM OVERSP LRE 10000lm 950mA R7038',
    '131W BOLA55 ORALED40 LED GR A-SYM LRE 40 x LUXEON T 1000mA R7038',
    '138W BOLA55 ORALED40 LED GR A-SYM LRM SMART 3K RAL7038',
    '13W BEGA 6593S 1XPLT13W 2P',
    '13W BOLA40 LED A-SYM LRM 100mA RAL7038',
    '140W BOLARMATUUR 55 EVSA 7038 CPO-TW140W',
    '140W SETGA AMS LUMINAIRE CPO-TW EVSA ST DIMMER',
    '140W SETGA AMS LUMINAIRE CPO-TW140W',
    '150W AEG OVERSP.KOFFER  M VSA_1XSON / CDO-ET150W',
    '150W AEG OVERSP.KOFFER  M VSA_1XSON / CDO-ET150W MGRIJS',
    '150W AEG OVERSP.KOFFER  M VSA_1XSON / CDO-ET150W MGRIJS+ZW',
    '150W AEG OVERSP.KOFFER  M VSA_1XSON / CDO-ET150W Onbekend',
    '150W AEG OVERSP.KOFFER  M VSA_1XSON / CDO-ET150W RAL7038',
    '150W AEG OVERSP.KOFFER SON/CDO-ET EVSA',
    '150W AEG OVERSP.KOFFER SON/CDO-ET EVSA GGALV',
    '150W AEG OVERSP.KOFFER SON/CDO-ET EVSA MGRIJS',
    '150W AEG OVERSP.KOFFER SON/CDO-ET EVSA Onbekend',
    '150W AEG OVERSP.KOFFER SON/CDO-ET EVSA RAL7038',
    '150W AEG OVERSP.KOFFER_1XSON-T / CDO-TT 150W',
    '150W AEG OVERSP.KOFFER_1XSON-T / CDO-TT 150W MGRIJS',
    '150W BOLARMATUUR 55 EVSA 3007 SON-T150W',
    '150W BOLARMATUUR 55 EVSA 7038 SON-T150W',
    '150W CONSTRUCTIONS-LICHT AMSTERDAM 1XCDO-ET150 Onbekend',
    '150W CONSTRUCTIONS-LICHT AMSTERDAM 1XCDO-ET150 RAL9006',
    '150W CONSTRUCTIONS-LICHT AMSTERDAM 1XCDO-ET150 RAL9007',
    '150W HAHN A11 1XCDO-ET 150W E40 ',
    '150W HAHN A11 1XCDO-ET 150W E40 MGRIJS',
    '150W HAHN A11 1XCDO-ET 150W E40 Onbekend',
    '150W HAHN A11 1XCDO-ET 150W E40 RAL7038',
    '150W HAHN A11 1XCDO-ET 150W E40 RAL9007',
    '150W HAHN A11 HCI-E/P 150W E27 ',
    '150W HAHN A11 HCI-E/P 150W E27 RAL9007',
    '150W RAGNI PRO550 SON_SON-T_CDO-TT-CDO-ET Onbekend',
    '150W RAGNI PRO550 SON_SON-T_CDO-TT-CDO-ET RAL7038',
    '150W ZUMTOBEL VICTOR 7403B GROOT SON/SON-T 7038',
    '150W ZUMTOBEL VICTOR 7403B GROOT_ALLEEN CDO  7038',
    '150W ZUMTOBEL VICTOR 7403B GROOT_ALLEEN CDO 7038 ',
    '17W BOLA55 ORALED40 LED GR A-SYM ERS 40 X LUXEON T 100mA R7038',
    '18W SELUX BETA PENDEL SX447-23-9  2X PLL 18W RAL7038',
    '21W BOLA 40 1BLS12 ERS 3K 2400Lm RAL3007 Asym',
    '21W BOLA 40 1BLS12 ERS 3K 2400Lm RAL7038 Asym',
    '21W BOLA40 LED A-SYM LRM 26XLUXEON 1701LM 200mA RAL7038',
    '24W HF INDUSTRIA 2312 OVERSP. ARMATUUR 2XPLL 24W',
    '250W AEG OVERSPANNINGSKOFFER M VSA_1XSON250W',
    '250W AEG OVERSPANNINGSKOFFER M VSA_1XSON250W Onbekend',
    '250W HAHN A11 SON/HCI-E UNIT PROEF IN BESTAAND ARM MGRIJS',
    '250W HAHN A11 SON/HCI-E UNIT PROEF IN BESTAAND ARM RAL9007',
    '25W BOL KLEIN ASYM ERS 2500lm 250mA R3007',
    '25W BOL KLEIN ASYM ERS 2500lm 250mA R7038',
    '26W HAHN A6 - 2X26W PLC 2P',
    '26W HF HAHN-4XPLC26W/4P ',
    '26W HF HAHN-4XPLC26W/4P RAL7024',
    '28W S21-EEUW 24S LED CAT-B 350mA 830 INCL-OVERSP.BEUGEL RAL9006',
    '32W BOLARMATUUR 40 EVSA 7038 PLT32W',
    '32W HF LOUIS POULSEN-ICON MINI-BASIC-OVERS. PLT32',
    '32W HF ZUMTOBEL VICTOR 7401B KLEIN 1XPLT32W 7038',
    '35W BEGA 6196S CDM-T35W BEGA-SILVER',
    '36W HF AEG KLEINE OVERSP. 2XPLL36 W',
    '36W HF AEG KLEINE OVERSP. 2XPLL36 W ',
    '36W HF AEG KLEINE OVERSP. 2XPLL36 W MGRIJS',
    '36W HF AEG KLEINE OVERSP. 2XPLL36 W Onbekend',
    '36W HF AEG KLEINE OVERSP. 2XPLL36 W RAL7038',
    '36W HF INDUSTRIA LUXOR OVERP.ARM.SNN 1XPLL36W 4P RAL9005',
    '42W BOLARMATUUR 40 EVSA 3007 PLT42W',
    '42W BOLARMATUUR 40 EVSA 7038 PLT42W',
    '42W HF BEGA 9171S-HANGARMATUUR-2XPLT42W 4P RAL9005',
    '42W HF HAHN A6  1XPLT42W 4P RAL9007',
    '42W HF NORAL CATO 1XPLT42W 4P RAL7038',
    '42W HF NORAL CATO 1XPLT42W 4P RAL9005',
    '42W HF NORAL CATO 1XPLT42W 4P RAL9007',
    '42W HF ZUMTOBEL VICTOR 7401B KLEIN 1XPLT42W  7038',
    '43W BOLA 40 2BLS12 CLSB 3K 4200Lm RAL3007 Ovaal smal',
    '43W BOLA 40 2BLS12 CLSB 3K 4200Lm RAL7038 Ovaal smal',
    '43W BOLA 40 2BLS12 ERS 3K 4200Lm RAL7038 Asym',
    '43W BOLA 40 2BLS12 ERS 3K 4588Lm 550mA A-SYM RAL3007',
    '43W BOLA 40 2BLS12 LRE 3K 4200Lm RAL3007 Sym',
    '43W BOLA 40 2BLS12 LRE 3K 4200Lm RAL7038 Sym',
    '45W BOLARMATUUR 40 EVSA 7038 CPO-TW45W',
    '47W BOLA 55 GR A-SYM ORALED40 LRE 40 x LUXEON T350mA K3000 R7038',
    '47W BOLA 55 GR A-SYM ORALED40 LRM  40 x LUXEON T 350mA K3000 R7038',
    '49W BOL APOLLO KLEIN ASYM ERS 4200lm 550mA R7038',
    '49W BOL C-STEUN KLEIN ASYM ERS 4200lm 550mA R3007',
    '49W BOLA40 ORALED A-SYM 1.2 ERS 26X LUXEON 550mA RAL7038',
    '53W BOL GROOT ASYM ERS 400mA R7038',
    '53W BOL GROOT SYM LRE 43lm 400mA',
    '53W BOL ORALED40 OVERSP KLEIN  SYM LRE 47lm 600mA R7038',
    '53W BOL OVERSP KLEIN  SYM LRE 47lm 600mA R3007',
    '55W RAGNI TYPE ADAM QL55W 830 RAL7038',
    '60W BOLARMATUUR 40 EVSA 7038 CPO-TW60W',
    '60W BOLARMATUUR 55 EVSA 3007 CPO-TW60W',
    '60W BOLARMATUUR 55 EVSA 7038 CPO-TW60W',
    '60W ZUMTOBEL VICTOR 7401B KLEIN CPO-TW 7038',
    '60W ZUMTOBEL VICTOR 7403B GROOT CPO-TW 7038',
    '66W BOL APOLLO GROOT ASYM ERS 6000lm 500mA R7038',
    '66W BOL OVERSP GROOT SYM LRE 6000lm 500mA',
    '66W BOLA 55 4BLS12 ERS 3K 7200lm 70 RAL7038 Asym',
    '66W BOLA 55 4BLS12 LRE 3K 7200Lm RAL7038 Sym',
    '70W BEGA 8374AS OVERSP_CDO-ET_ SPIEGEL 9395 ',
    '70W BEGA 8374AS OVERSP_CDO-ET_ SPIEGEL 9395 BEGAZILV',
    '70W BEGA 8374S-CDO-ET-ZILVER-SPIGL9395',
    '70W BOLARMATUUR 40 EVSA 3007 SON-T70W',
    '70W BOLARMATUUR 40 EVSA 7038 SON-T70W',
    '70W BOLARMATUUR 55 EVSA 7038 SON-T70W',
    '70W CONSTRUCTIONS-LICHT AMSTERDAM  1XCDO-ET70 RAL9007',
    '70W HAHN A6 CDO-ET 70W E27 ',
    '70W HAHN A6 CDO-ET 70W E27 RAL9007',
    '70W JARNKONST ARM19845+BEU89461 M VSA 70 W ',
    '70W JARNKONST ARM19845+BEU89461 M VSA 70 W MGRIJS',
    '70W JARNKONST KLEIN BRUIN M/APP_1XSON70W INT ',
    '70W JARNKONST KLEIN BRUIN M/APP_1XSON70W INT MGRIJS',
    '70W JARNKONST KLEIN BRUIN M/APP_1XSON70W INT RAL8000',
    '70W JARNKONST TYPE 7424/4-70 WIT M VSA SON 70W',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W ',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W MGRIJS',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W Onbekend',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W RAL3005',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W RAL3007',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W RAL3011',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W RAL7037',
    '70W RAGNI PRO350 CDO-ET, SON EXT 70W RAL7038',
    '70W RAGNI PRO350 DIMPROEF CDO-ET, SON EXT 70W',
    '70W RAGNI PRO350 SON70W INT-E27 ',
    '70W RAGNI PRO350 SON70W INT-E27 MGRIJS',
    '70W RAGNI PRO350 SON70W INT-E27 Onbekend',
    '70W RAGNI PRO350 SON70W INT-E27 RAL5011',
    '70W ZUMTOBEL VICTOR 7401B KLEIN_ALLEEN CDO  7038',
    '70W ZUMTOBEL VICTOR 7401B KLEIN_ALLEEN CDO 7038 ',
    '70W ZUMTOBEL VICTOR 7401B KLEIN_ALLEEN CDO 7038 MGRIJS',
    '70W ZUMTOBEL VICTOR 7401B KLEIN_ALLEEN CDO 7038 Onbekend',
    '70W ZUMTOBEL VICTOR 7403B GROOT_ALLEEN CDO  7038',
    '79W BOLA 40 3BLS12 LRE 2200K 5900LM 700mA RAL8008',
    '80W ECLATEC BOLA50 ORALED36',
    '80W HAHN A11 LED 3000K RAL9007',
    '85W BOLA55 ORALED40 GR A-SYM LRM 650 mA RAL7038',
    '90W BOLARMATUUR 55 EVSA 3007 CPO-TW90W',
    '90W BOLARMATUUR 55 EVSA 7038 CPO-TW90W',
    '91W BOLA55 ORALED40 GR SYM LRE 40X LUXEON T 700mA RAL7038',
    '91W BOLA55 ORALED40 GR SYM LRE 40X LUXEON T 700mA RAL7038',
    '96W SCHREDER DEXO LED 500mA K4000 AKZO150GS',
    'AEG  -OVSP UNI ZVSASN/CDOET',
    'AEG  -OVSP UNI ZVSASN/CDOET MGRIJS',
    'SCALA MIDI 1753 1XPLL24 HF + SRD BEUGEL ',
    'SCALA MIDI 1753 1XPLL24 HF + SRD BEUGEL RAL7021',
    'SCALA MIDI 1753 2XPLL24 HF + SRD BEUGEL ',
    'SCALA MIDI 1753 2XPLL24 HF + SRD BEUGEL RAL7021',
    'UNIV. AEG ARM36631+BEU88801 KLEINE KOFFER Z VSA ',
    'UNIV. AEG ARM36631+BEU88801 KLEINE KOFFER Z VSA MGRIJS',
    'UNIV. AEG ARM36631+BEU88801 KLEINE KOFFER Z VSA Onbekend',
    'UNIV. AEG ARM36631+BEU88801 KLEINE KOFFER Z VSA RAL7038',
    'UNIV. JARNKONST Z/APPARAAT MGRIJS',
    'UNIV. PHILIPS-S-HDS-201/250/150',
    'UNIV. PHILIPS-S-HDS-201/250/150 MGRIJS',
    'UNIV. PHILIPS-S-HDS-201/250/150 Onbekend',
];

export function getArmatuurLeverancierstypeOptions() {
    return list.map((i) => ({ text: i, value: i }));
}
